import React from 'react';
import styled from 'styled-components';
import { ReactComponent as AlertTriangle } from '../../assets/images/svg/alert-triangle.svg';
import themeColors from '../../assets/styles/themeColors';
import { mediaBelow, pxToRem, pxToRemMd } from '../../assets/styles/helper';
import { variables } from '../../assets/styles/variables';

const WarningIcon = styled(AlertTriangle)`
  width: ${pxToRem(20)};
  height: ${pxToRem(20)};
  color: ${themeColors.colorRed};
  margin-right: ${pxToRem(2)};

  ${mediaBelow(variables.breakpoints.bpXl)} {
    width: ${pxToRemMd(20)};
    height: ${pxToRemMd(20)};
    margin-right: ${pxToRemMd(8)};
  }
`;

const MissingInfoLabel = styled.div`
  color: ${themeColors.colorRed};
`;
const MissingInfoContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

const MissingInfo = () => (
  <MissingInfoContainer>
    <WarningIcon />
    <MissingInfoLabel>Missing info</MissingInfoLabel>
  </MissingInfoContainer>
);

MissingInfo.propTypes = {};

export default MissingInfo;
